export default __webpack_public_path__ + "static/media/2022_November_Spaziergang.f374aea3.webp";